import CompanyDetails from "../payroll-setup/CompanyDetails";
import EmployeeDetails from "../payroll-setup/EmployeeDetails";
import PaySchedule from "../payroll-setup/PaySchedule";

export default class PayrollSetupManager {
    static getAllCreationSteps(onClickHandler) {
        return [
          {
            title: "Company Details",
            requiredProps: [],
            reqError: "Please fill the details",
            getChild: (props) => (
              <CompanyDetails setData={props.setData} formFields={props.formFields} {...props} ref={props.ref}/>
            ),
            onClick: (event) => onClickHandler(event, 0),
          },

          {
            title: "Pay Schedule",
            requiredProps: [],
            reqError: "",
            getChild: (props) => (
              <PaySchedule setData={props.setData} formFields={props.payScheduleFormFields} {...props} ref={props.ref}/>
            ),
            onClick: (event) => onClickHandler(event, 1),
          },
          {
            title: "Employee Details",
            requiredProps: [],
            reqError: "Please provide data for required columns",
            getChild: (props) => (
              <EmployeeDetails {...props}/>
            ),
            onClick: (event) => onClickHandler(event, 2),
          },
        ];
      }
}